import { tokens } from '@flysas-tech/commercial-ui';

import { theme } from '../legacyComponents/theme';

export const productCardColors = {
  LIGHT: {
    backgroundColor: tokens.color.gray['100'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  STANDARD: {
    backgroundColor: tokens.color.turquoise['90'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  FLEX: {
    backgroundColor: tokens.color.turquoise['80'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  PREMIUM: {
    backgroundColor: tokens.color.blue['50'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  PREMIUMFLEX: {
    backgroundColor: tokens.color.blue['40'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  BUSINESS: {
    backgroundColor: tokens.color.blue['30'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  BUSINESSFLEX: {
    backgroundColor: tokens.color.blue['20'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  ECONOMYSPORT: {
    backgroundColor: tokens.color.turquoise['90'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  PREMIUMSPORT: {
    backgroundColor: tokens.color.blue['40'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  BUSINESSSPORT: {
    backgroundColor: tokens.color.blue['20'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  ECONOMYMUSIKK: {
    backgroundColor: tokens.color.turquoise['90'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  PREMIUMMUSIKK: {
    backgroundColor: tokens.color.blue['40'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  BUSINESSMUSIKK: {
    backgroundColor: tokens.color.blue['20'],
    color: tokens.color.white,
    infoIconColor: tokens.color.white,
  },
  SASYOUNGLIGHT: {
    backgroundColor: tokens.color.gray['100'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  SASYOUNGSMART: {
    backgroundColor: tokens.color.turquoise['80'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  SASYOUNGSTANDARD: {
    backgroundColor: tokens.color.turquoise['90'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  SASYOUNGBIO: {
    backgroundColor: tokens.color.bio['80'],
    color: tokens.color.gray['20'],
    infoIconColor: tokens.color.black,
  },
  DEFAULT: {
    backgroundColor: tokens.color.gray['100'],
    color: tokens.color.black,
    infoIconColor: tokens.color.black,
  },
};

export const legacyProductCardColors = {
  SASGOLIGHT: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOLIGHTYOUTH: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUNGLIGHT: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOSMART: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUNGSMART: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUNGSTANDARD: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOBONUS: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-blue)',
  },
  SASPLUSBONUS: {
    backgroundColor: 'var(--color-blue-3)',
    color: theme.colors.gray20,
    infoIconColor: theme.colors.white,
  },
  SASBUSINESSBONUS: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.gray20,
    infoIconColor: theme.colors.white,
  },
  SASGOSMARTSPORT: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOSPORT: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOSMARTYOUTH: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUTHGOSMART: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOSMARTBIO: {
    backgroundColor: theme.colors.bio80,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUTHBIO: {
    backgroundColor: theme.colors.bio80,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASYOUNGBIO: {
    backgroundColor: theme.colors.bio80,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGOPRO: {
    backgroundColor: 'var(--color-blue-1-2)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASPLUSSMART: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSSMARTSPORT: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSSPORT: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSPRO: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSPROBIO: {
    backgroundColor: theme.colors.bio30,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASBUSINESSSMART: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASBUSINESSSMARTSPORT: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASBUSINESSPRO: {
    backgroundColor: 'var(--color-blue-4-hover)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSCORPORATE: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASGOCORPORATE: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASGO: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  SASPLUS: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  ECONOMY: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: theme.colors.blue40,
  },
  PREMIUM_ECONOMY: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  BUSINESS: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASBUSINESS: {
    backgroundColor: theme.colors.blue20,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  TRAVELPASSUNLIMITED: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  TRAVELPASSMULTIPLEUSERS: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  SASPLUSFULLFLEX: {
    backgroundColor: theme.colors.blue30,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  LIGHT: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  STANDARD: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  FLEX: {
    backgroundColor: 'var(--color-blue-1-2)',
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  PREMIUM: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  PREMIUMFLEX: {
    backgroundColor: 'var(--color-blue-3)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  BUSINESSFLEX: {
    backgroundColor: 'var(--color-blue-4-hover)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  ECONOMYSPORT: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  PREMIUMSPORT: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  BUSINESSSPORT: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  ECONOMYMUSIKK: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-icon)',
  },
  PREMIUMMUSIKK: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  BUSINESSMUSIKK: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  BUSINESSTPC: {
    backgroundColor: theme.colors.blue30,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  ECONOMYTPC: {
    backgroundColor: theme.colors.blue40,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  PREMIUMTPC: {
    backgroundColor: theme.colors.blue30,
    color: theme.colors.white,
    infoIconColor: theme.colors.white,
  },
  ECONOMYBONUS: {
    backgroundColor: theme.colors.turquoise90,
    color: theme.colors.gray20,
    infoIconColor: 'var(--color-blue)',
  },
  PREMIUMBONUS: {
    backgroundColor: 'var(--color-blue-3)',
    color: theme.colors.gray20,
    infoIconColor: theme.colors.white,
  },
  BUSINESSBONUS: {
    backgroundColor: 'var(--color-blue-4)',
    color: theme.colors.gray20,
    infoIconColor: theme.colors.white,
  },
  DEFAULT: {
    backgroundColor: 'var(--color-gray-1)',
    color: theme.colors.black,
    infoIconColor: 'var(--color-icon)',
  },
};
